<div class="slider-container " [style.width]="width" [@slide]="visibility" [style.display]="useDisplay? 'block' : 'none'" >
  <div id="close-btn" class="close-btn -translate-x-full transform cursor-pointer bg-gray-50 p-4 hover:text-gray-500 dark:bg-gray-900 dark:text-gray-300 dark:border-l dark:border-gray-600 dark:border-b rounded-l-lg"
    (click)="close()">
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
      class="w-6 h-6">
      <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
    </svg>

  </div>
  <ng-content></ng-content>
</div>
